import React from 'react'
import { RadioGroup as RadioGroupMUI } from '@mui/material'
import PropTypes from 'prop-types'

const RadioGroup = props => {
  return <RadioGroupMUI {...props} />
}

RadioGroup.propTypes = {
  classes: PropTypes.object,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  row: PropTypes.bool,
  onChange: PropTypes.func,
}

export default RadioGroup
